export default __webpack_public_path__ + "pgnv-assets/d74dc58fdf31d85591633f7c5293b4b1.png";